// pl_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const plPmsGroups = {

  title:       "Grupy i wydarzenia",
  description: "Operacyjny przegląd rezerwacji grupowych i powiązanych wydarzeń.",
  filters:     "Filtry",
  filtersHint: "Szybko zawęź rezerwacje grupowe z dużą liczbą wydarzeń.",
  none:        "Brak",

} as const;

export default plPmsGroups;
